export default __webpack_public_path__ + "static/media/illustrationCompanyDisabledRedencao.7e89b39a.svg";